import { memo, useState } from 'react';

import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

import { validateSlackChannel } from '../validation';

type SlackChannelSectionProps = {
  value: string;
  label: string;
  onChange: (value: string) => void;
};

export const SlackChannelSection = memo(
  ({ value, label, onChange }: SlackChannelSectionProps) => {
    const [error, setError] = useState('');

    const handleChange = (next: string) => {
      setError(validateSlackChannel(next));
      onChange(next);
    };

    return (
      <FormControl fullWidth variant="standard" required error={Boolean(error)}>
        <TextField
          id="slack-channel"
          label={label}
          size="small"
          variant="standard"
          required
          value={value}
          error={Boolean(error)}
          onChange={e => handleChange(e.target.value)}
          helperText={
            error || 'Public Slack channel for notifications and reach out'
          }
        />
      </FormControl>
    );
  },
);
